import React from 'react';

import cert4000 from './images/4000.png';
import cert5000 from './images/5000.png';
import cert6000 from './images/6000.png';

export const certificates = [
    {
        id: 1,
        price: 4000,
        image: cert4000,
        color: '#E8D9E0',
        quote: '«Я всегда на твоей стороне»'
    },
    {
        id: 2,
        price: 5000,
        image: cert5000,
        color: '#D1DAE1',
        quote: '«Этот ключ поможет тебе в поиске ответов»'
    },
    {
        id: 3,
        price: 6000,
        image: cert6000,
        color: '#DBD4E4',
        quote: '«За пределами представлений о правильных и неправильных\nдействиях есть поле. Я встречу тебя там». Руми'
    }
]

export const eFaq = [{
    question: 'Как воспользоваться электронным сертификатом?',
    answer: `
        <p>
            На почту, которую Вы указали в качестве получателя сертификата в графе «Ваш e-mail» или 
            «E-mail получателя сертификата» (если Вы выбрали вариант отправки сертификата сразу на почту другу), 
            придет кодовое слово. Чтобы активировать сертификат, кодовое слово необходимо ввести в поле 
            «Пополнить баланс» в разделе «Профиль» в Вашем личном кабинете на сайте 
            <a href='/profile' target='__blank'>www.otvet.co</a>. Если у Вас или Вашего друга еще нет личного кабинета 
            на сайте, то его нужно создать. Создать личный кабинет можно <a id='register' href='?register=true' target='_blank'>тут</a>
        </p>
        <p>
            После ввода кодового слова сумма сертификата будет отображаться в строке 
            «Ваш баланс» в личном кабинете пользователя в разделе «Профиль».
        </p>
        <p style='color: #1C5E47'>
            Срок действия сертификата — бессрочный.
        </p>
        <p>
            Теперь при оформлении консультации у специалиста у Вас есть несколько вариантов того, 
            как можно произвести оплату сеанса:
        </p>
        <ul>
            <li>оплатить консультацию сертификатом (используя «Ваш баланс»);</li>
            <li>оплатить консультацию частично текущим балансом, частично банковской картой (в случае, например, если стоимость консультации превышает баланс в профиле);</li>
            <li>если сумма сертификата превышает стоимость сеанса у специалиста, баланс будет снят частично. Оставшуюся сумму Вы можете использовать при оплате следующей сессии.</li>
        </ul>
        <p>
            Сертификат можно использовать для оплаты консультаций со специалистами команды Otvet. На покупки в 
            интернет-магазине действие сертификата не распространяется.
        </p>
    `
}]

export const printedFaq = [{
    question: 'Как воспользоваться печатным сертификатом?',
    answer: `
        <p>
           Печатный сертификат дает Вам возможность приобрести консультацию со специалистом проекта Otvet.
           Сертификат можно активировать в течение 12 месяцев со дня покупки.
           После активации сертификата сумма на счете может находиться бессрочно.
        </p>
        <p>
            Чтобы активировать печатный сертификат, необходимо ввести кодовое слово в поле «Пополнить баланс» 
            в разделе «Профиль» в Вашем личном кабинете на сайте <a href='/profile' target='__blank'>www.otvet.co</a>.
        </p>
        <p>
            После ввода кодового слова сумма, указанная в сертификате, 
            будет отображаться в строке «Ваш баланс» в личном кабинете пользователя в разделе «Профиль».
        </p>
    `
}]
